var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44198",
    "data-name": "Group 44198",
    transform: "translate(-1112 -478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_361",
    "data-name": "Ellipse 361",
    transform: "translate(1112 478)",
    fill: "none",
    stroke: "#06c258",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_88421",
    "data-name": "Path 88421",
    d: "M-14289.728-8274.749l2.428,2.622,4.863-4.863",
    transform: "translate(15407.082 8761.559)",
    fill: "none",
    stroke: "#06c258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircle);
export default __webpack_public_path__ + "static/media/green-circle.6dd85da6aaf78dc179d9b759c87cbeb5.svg";
export { ForwardRef as ReactComponent };